import { useFormik } from 'formik'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import ModalComponent from '../../../core/common/modal/ModalComponent'
import { useActiveInactiveRolesMutation, useDeactivateUserToggleMutation } from '../../../services/EndPointsApis'
import { all_routes } from '../../router/all_routes'

type Props = {
    show: boolean
    handleClose: () => void
    data?: any
    setCurrentToggleState:any
    refetch?:any
    handleDelete:any
}

const ActiveUserModal = ({ show, handleClose, data ,setCurrentToggleState,refetch,handleDelete}: Props) => {
    const route = all_routes;
    const [activeInactiveRole, { data: deActivedata, isError, error, isSuccess }] = useActiveInactiveRolesMutation();
    const navigate = useNavigate();

    const initialValues =
        [
            {
                roleId: 0,
                isActive: true
            }
        ]
    const formik = useFormik({
        initialValues,
        onSubmit: (values, { resetForm }) => {

            activeInactiveRole([
                {
                    roleId: data?.id,
                    isActive: data?.active===true ? false :true
                }
            ])

        },
    });
    const { resetForm } = formik;

    useEffect(() => {
        if (isSuccess) {
            toast.success(deActivedata?.result?.value?.message);
            handleClose();
            handleDelete(data?.id)
            if (data?.active === true) {
                setCurrentToggleState(false)
              }else{
                setCurrentToggleState(true)
              }
            refetch()
        }
    }, [isSuccess,setCurrentToggleState]);
    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    },
        [isError, error]);
    return (
        <ModalComponent
            buttonText=""
            modalTitle={data?.active!==true ?'Activate Role':"Deactivate Role"}
            onClose={handleClose}
            onSave={formik.handleSubmit}
            isVisible={show}
            cancelButton="No"
            saveButton='Yes'
        >
            <>
                <p>
                    Are you sure you want to {data?.active!==true ?'Activate Role?':"Deactivate Role?"}</p>
            </>

        </ModalComponent>
    )
}

export default ActiveUserModal